import { render, staticRenderFns } from "./CreateAsset.vue?vue&type=template&id=6de6170f&scoped=true"
import script from "./CreateAsset.vue?vue&type=script&lang=js"
export * from "./CreateAsset.vue?vue&type=script&lang=js"
import style0 from "./CreateAsset.vue?vue&type=style&index=0&id=6de6170f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de6170f",
  null
  
)

export default component.exports